<form id="locationForm" name="locationForm" role="form" *ngIf="locationFormGroup" [formGroup]="locationFormGroup">
  <div class="formgrid grid">
    <div class="field col-12" *ngIf="isNew">
      <label for="companyName">Company name <span class="text-red-500">*</span></label>
      <input
        pInputText
        id="companyName"
        name="companyName"
        type="text"
        formControlName="companyName"
        [ngClass]="{ 'w-full': true, 'text-sm': true, 'ng-invalid': isControlInvalid('companyName') }"
        [required]="true"/>
      <ul class="error-form-text" *ngIf="isControlInvalid('companyName')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-6">
      <label for="firstName">First name <span class="text-red-500">*</span></label>
      <input
        pInputText
        id="firstName"
        name="firstName"
        type="text"
        formControlName="firstName"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('firstName') }"
        [required]="true"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('firstName')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-6">
      <label for="lastName">Last name <span class="text-red-500">*</span></label>
      <input
        pInputText
        id="lastName"
        name="lastName"
        type="text"
        formControlName="lastName"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('lastName') }"
        [required]="true"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('lastName')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-6">
      <label for="addressLineOne">Address line 1 <span class="text-red-500">*</span></label>
      <input
        pInputText
        id="addressLineOne"
        name="addressLineOne"
        type="text"
        formControlName="addressLineOne"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('addressLineOne') }"
        [required]="true"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('addressLineOne')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-6">
      <label for="addressLineTwo">Address line 2</label>
      <input
        pInputText
        id="addressLineTwo"
        name="addressLineTwo"
        type="text"
        formControlName="addressLineTwo"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('addressLineTwo') }"/>
    </div>
    <div class="field col-4">
      <label for="state" style="display:block">State <span class="text-red-500">*</span></label>
      <p-dropdown
        inputId="state"
        name="state"
        [options]="states"
        formControlName="state"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        placeholder="Select a state"
        appendTo="body"
        [style]="{ width: '100%' }"
        [ngClass]="{ 'w-full':true,'text-sm': true }"
        (onChange)="onStateChange($event)"/>
    </div>
    <div class="field col-4">
      <label for="city" style="display:block">City <span class="text-red-500">*</span></label>
      <p-dropdown
        inputId="city"
        name="city"
        [options]="cities"
        formControlName="city"
        optionLabel="name"
        placeholder="Select a city"
        [filter]="true"
        filterBy="name"
        appendTo="body"
        [style]="{ width: '100%' }"
        [ngClass]="{ 'w-full':true,'text-sm': true }"
        (onChange)="onCityChange($event)"/>
    </div>
    <div class="field col-4">
      <label for="zipCode" style="display:block">Zip Code <span class="text-red-500">*</span></label>
      <input
        pInputText
        id="zipCode"
        name="zipCode"
        type="text"
        pattern="[0-9]{5}"
        formControlName="zipCode"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('zipCode') }"
        [required]="true"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('zipCode')">
        <li>This field is required</li>
        <li>Only numbers allowed</li>
        <li>5 digits are mandatory</li>
      </ul>
    </div>
  </div>
</form>
<div class="p-dialog-footer">
  <button pButton type="button" label="Save" icon="pi pi-save" (click)="save()"
          [disabled]="locationFormGroup.invalid" *ngIf="locationFormGroup"></button>
  <button pButton type="button" label="Cancel" icon="pi pi-times" (click)="cancel()"></button>
</div>
